const socials = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/dylanzajac",
    path: "M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.29c-.96 0-1.75-.79-1.75-1.75s.79-1.75 1.75-1.75 1.75.79 1.75 1.75-.79 1.75-1.75 1.75zm13.5 10.29h-3v-4.5c0-1.07-.93-2-2-2s-2 .93-2 2v4.5h-3v-9h3v1.16c.59-.88 1.81-1.16 3-1.16 2.21 0 4 1.79 4 4v5z",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/dylanzzzajac",
    path: "M7.75 2h8.5A5.76 5.76 0 0 1 22 7.75v8.5A5.76 5.76 0 0 1 16.25 22h-8.5A5.76 5.76 0 0 1 2 16.25v-8.5A5.76 5.76 0 0 1 7.75 2zm0 1.5A4.26 4.26 0 0 0 3.5 7.75v8.5A4.26 4.26 0 0 0 7.75 20.5h8.5A4.26 4.26 0 0 0 20.5 16.25v-8.5A4.26 4.26 0 0 0 16.25 3.5h-8.5zm4.25 3a5.75 5.75 0 1 1 0 11.5 5.75 5.75 0 0 1 0-11.5zm0 1.5a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5zm5.25-.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z",
  },
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@dylanzajac",
    path: "M16.5 3a5.49 5.49 0 0 0 3.5 1.25V7a7.99 7.99 0 0 1-3.5-.77V14a5.5 5.5 0 1 1-5.5-5.5h1v2.75h-1a2.75 2.75 0 1 0 2.75 2.75V3h3.75z",
  },
  {
    label: "Twitter / X",
    href: "https://x.com/dylanzzzajac",
    path: "M22 5.92c-.77.34-1.6.57-2.46.68a4.17 4.17 0 0 0 1.83-2.31 8.29 8.29 0 0 1-2.63 1 4.14 4.14 0 0 0-7.06 3.78A11.75 11.75 0 0 1 3.15 4.6a4.14 4.14 0 0 0 1.28 5.52 4.09 4.09 0 0 1-1.87-.52v.05a4.14 4.14 0 0 0 3.32 4.05 4.18 4.18 0 0 1-1.86.07 4.15 4.15 0 0 0 3.87 2.88A8.3 8.3 0 0 1 2 19.54a11.73 11.73 0 0 0 6.29 1.84c7.55 0 11.68-6.26 11.68-11.68v-.53A8.36 8.36 0 0 0 22 5.92z",
  },
];

export default function Contact() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-white flex flex-col pt-[57px] md:pt-0">

      {/* Zoho form iframe */}
      <div className="flex-1 w-full">
        <iframe
          src="https://forms.zohopublic.com/Computers4People/form/ContactDylanZajac/formperma/1b0CwrI9OwUM40hU9cw7L7U6Q8km16alBZBsjBZVHDY"
          title="Contact Form"
          style={{ border: "none", minHeight: "760px" }}
          className="w-full h-full"
          frameBorder="0"
          scrolling="yes"
          allowFullScreen
        />
      </div>

      {/* Social icons */}
      <div className="flex items-center justify-center gap-7 py-8 text-gray-300">
        {socials.map(({ label, href, path }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="hover:text-black transition-colors duration-200"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="h-5 w-5">
              <path d={path} />
            </svg>
          </a>
        ))}
      </div>

      <p className="text-[10px] text-gray-300 text-center pb-5">
        © {currentYear} Dylan Zajac. All rights reserved.
      </p>
    </div>
  );
}
